import { render, staticRenderFns } from "./TabAttachFiles.vue?vue&type=template&id=406d91a8&"
import script from "./TabAttachFiles.vue?vue&type=script&lang=js&"
export * from "./TabAttachFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports